<template>
  <div
    class="button-collapse"
    :class="classes"
  >
    <div
      class="header d-flex flex-column-reverse flex-lg-row"
      :class="{ 'cursor-pointer': collapse }"
      @click="$emit('show')"
    >
      <div class="d-flex flex-column mr-auto">
        <p class="title">
          {{ title }}
        </p>

        <slot name="subtitle">
          <span class="subtitle">{{ subtitle }}</span>
        </slot>
      </div>

      <template v-if="collapse">
        <a class="ml-auto">
          <GjIcon name="ArrowDown" />
        </a>
      </template>

      <template v-else>
        <div class="d-lg-flex ml-auto mb-1 mb-lg-0 top-fade-in">
          <b-button
            v-if="save"
            variant="bg-primary"
            :disabled="disableSave"
            @click.stop="onSave()"
          >
            Save Changes
          </b-button>
          <b-button
            variant="bg-white"
            class="ml-1"
            @click.stop="onCancel()"
          >
            {{ cancelTitle }}
          </b-button>
        </div>
      </template>
    </div>

    <div
      class="body  "
      :class="collapse ? 'collapse fade-out' : 'top-fade-in'"
    >
      <slot name="body" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ButtonCollapse',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    save: {
      default: true,
      type: Boolean,
    },
    cancelTitle: {
      default: 'Cancel',
      type: String,
    },
    collapse: {
      default: true,
      type: Boolean,
    },
    disableSave: {
      default: false,
      type: Boolean,
    },
    classes: {
      default: '',
      type: String,
    },
  },

  data() {
    return {
      nr: 1,
    }
  },
  methods: {
    onCancel() {
      this.$emit('cancel')
    },
    onSave() {
      this.$emit('save')
    },
  },
}
</script>
<style lang="scss" scoped>
.button-collapse {
  margin: 0 24px 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid#E0E5EB;

  .header {
    font-weight: 500;
    align-items: center;
    .subtitle {
      font-size: 12px;
    }
  }

  .body {
    margin-top: 16px;
  }
}
</style>
